export const concat = (chaine1, chaine2, separator) => {
  if (chaine1 == null) {
    chaine1 = ''
  }
  if (chaine2 == null) {
    chaine2 = ''
  }
  if (separator == null || chaine1 === '' || chaine2 === '') {
    separator = ''
  }
  return chaine1 + separator + chaine2
}

export const getExtranetUrl = (page) => {
  return process.env.VUE_APP_URL_XTRANET + page
}

export const getSacUrl = (userId) => {
  if (userId) {
    return process.env.VUE_APP_PUBLIC_PATH + "sac-request/" + userId.toString()
  }

  return process.env.VUE_APP_PUBLIC_PATH + "sac-request"
}